module.exports = __webpack_public_path__ + "img/22.059deb54.jpg";